import { Component, ComponentPropsWithRef } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import _ from "lodash";
import AjaxLoader from "./ajax_loader";
import m from "@utils/strings";
import userManager from "@utils/userManager";
import { getPrestador, updatePrestador } from "@store/actions";

export interface IPrestadorValidatorState {
  isFetchingPrestador: boolean;
  showPrestadorLoader: boolean;
}

export interface IPrestadorValidatorProps extends ComponentPropsWithRef<"div"> {
  user?: any;
  prestador?: any;
  getPrestador?: any;
  updatePrestador?: any;
}

const INITIAL_STATE = {
  showPrestadorLoader: false,
  isFetchingPrestador: false,
};

class ValidatePrestadorLoader extends Component {
  state: IPrestadorValidatorState;
  props: IPrestadorValidatorProps;
  constructor(props: IPrestadorValidatorProps) {
    super(props);
    this.state = INITIAL_STATE;
    this.props = props;
  }

  getUpdatePrestador = () => {
    const { user } = this.props;
    if (user != null && user.profile != null) {
      if (!this.state.isFetchingPrestador) {
        this.state.isFetchingPrestador = true;
        let cpfCnpj =
          user.profile.prestador instanceof Array
            ? user.profile.prestador[0]
            : user.profile.prestador;
        this.props.getPrestador(cpfCnpj, (result: any) => {
          this.props.updatePrestador(result);
          this.setState({
            showPrestadorLoader: false,
            isFetchingPrestador: false,
          });
        });
      }
    }
  };

  componentDidUpdate() {
    this.verifiyIfUserIsAuthenticated();
  }

  componentDidMount() {
    this.verifiyIfUserIsAuthenticated();
    if (_.isEmpty(this.props.prestador)) {
      this.setState({ showPrestadorLoader: true, isFetchingPrestador: true });
      this.getUpdatePrestador();
    }
  }

  verifiyIfUserIsAuthenticated = () => {
    const { user } = this.props;
    if (!user || user.expired) {
      userManager.signinRedirect();
    }
  };

  render = () => {
    const { showPrestadorLoader } = this.state;

    const PrestadorLoader = showPrestadorLoader ? (
      <AjaxLoader
        ajaxMessage={
          m.TELA_CONSULTA_PRONTO_SOCORRO.MENSAGEM_LOADER_BUSCANDO_PRESTADOR
        }
      />
    ) : (
      ""
    );
    return PrestadorLoader;
  };
}

const mapStateToProps = (state: any) => ({
  user: state.oidc.user,
  prestador: state.prestador,
});

const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    {
      getPrestador,
      updatePrestador,
    },
    dispatch
  );

//@ts-expect-error
export default connect(mapStateToProps, mapDispatchToProps)(ValidatePrestadorLoader);
